<template>
  <component :is="layout" />
</template>
<script>
import EmptyLayout from '@/Layouts/EmptyLayout.vue';
import RegLayout from '@/Layouts/RegLayout.vue';
import ProfileLayout from '@/Layouts/ProfileLayout.vue';
import WebLayout from '@/Layouts/WebLayout.vue';
import NoHeaderLayout from '@/Layouts/NoHeaderLayout.vue';
import ReportLayout from '@/Layouts/ReportLayout.vue';

export default {
  name: "App",
  data() {
    return {
      layout: null,
    };
  },
  components: {
    EmptyLayout,ProfileLayout,WebLayout,RegLayout,NoHeaderLayout,ReportLayout
  },
  watch: {
    $route(to) {
      if (to.meta.layout !== undefined) {
        this.layout = to.meta.layout
        if(to.meta.layout == "WebLayout" && window.innerWidth <= 768){
          $(document.querySelector('.headerMenuBox')).slideUp();
        }
      } else {
        this.layout = "EmptyLayout"
      }
      window.scrollTo(0, 0);
    },
  },
};
</script>